// lenis-scroll.js
import Lenis from 'lenis'
import AbstractComponent from "./abstract-component"
import { debounce } from "lodash"

export default class LCS extends AbstractComponent {
    constructor(el) {
        super(el)
        this._rafId = null
        this._resizeHandler = null
        this.init()
    }

    init() {
        this.createScroll()
        this.bindResize()
    }

    createScroll() {
        this.lenis = new Lenis({
            duration: 0.8,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            smoothTouch: false,
            gestureOrientation: 'vertical',
            wheelMultiplier: 1.0,
            prevent: (node) => this.shouldPreventLenisScroll(node),
        })

        this.lenis.on('scroll', (data) => {
            this.app?.emit?.('scroll', data);
        })

        const raf = (time) => {
            this.lenis.raf(time)
            this._rafId = requestAnimationFrame(raf)
        }
        this._rafId = requestAnimationFrame(raf)
    }

    shouldPreventLenisScroll(node) {
        if (!node?.closest) {
            return false;
        }
        return !!node.closest(
            '.c-google-map__map-wrap, [data-lenis-prevent], [data-lenis-prevent-wheel]'
        );
    }

    bindResize() {
        // Mettre à jour Lenis lors du resize pour recalculer les dimensions
        this._resizeHandler = debounce(() => {
            if (this.lenis) {
                this.lenis.resize()
            }
        }, 150)
        
        window.addEventListener('resize', this._resizeHandler, { passive: true })
    }

    disable() { this.lenis?.stop() }
    enable() { this.lenis?.start() }

    scrollTo(target, offset = 0) {

        this.lenis?.scrollTo(target, {
            offset,
            duration: 1,
            //easing: (t) => 1 - Math.pow(1 - t, 3),
            immediate: false,
            lock: false,
            force: false,
        })
    }

    update() { 
        // Mettre à jour Lenis si nécessaire
        if (this.lenis) {
            this.lenis.resize()
        }
    }

    destroy() {
        if (this._rafId) cancelAnimationFrame(this._rafId)
        if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler)
        }
        this.lenis?.destroy()
        this.lenis = null
    }
}
